import React, { useState } from "react";
import { Button } from "@components/shared";
import axios from "axios";
import toast from "react-hot-toast";

export default function DownloadZipFileButton() {
  const [loading, setLoading] = useState(false);

  function onClick() {
    setLoading(true);
    axios
      .get("/db-zip/", {
        responseType: "blob",
      })
      .then((res) => {
        const blob = new Blob([res.data], { type: "application/zip" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        const now = new Date();
        const date = now.toISOString().split("T")[0];
        const time = now.toTimeString().split(" ")[0].replace(/:/g, "-");
        link.setAttribute("download", `database-${date}_${time}.zip`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err.message || "Failed to download file");
      });
  }

  return (
    <Button.Basic
      onClick={onClick}
      loading={loading}
      text="Download Database Zip File"
      primary
    />
  );
}
